const { classify } = require("./lib/helpers");
var pym = require("./lib/pym");
require("./lib/webfonts");

// Global vars
var pymChild = null;
var renderStackedBarChart = require("./renderStackedBars");
var skipLabels = ["label", "category", "values", "chart"];
var charts = [];

var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min")
};

// Initialize the graphic.
var onWindowLoaded = function() {
  var data = formatData(window.DATA);
  render(data);

  window.addEventListener("resize", () => render(data));

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
  });
};

// Format graphic data for processing by D3.
var formatData = function(input) {
  var data = input.map(function(d) {
    var x0 = 0;

    var { category, label, chart } = d;
    var values = [];

    for (var name in d) {
      if (skipLabels.indexOf(name) > -1) {
        continue;
      }

      var x1 = x0 + d[name];
      var val = d[name];

      values.push({
        label: name,
        x0,
        x1,
        val
      });

      x0 = x1;
    }
    return {category, label, chart, values };

  });
  charts = data.map(o => o['chart']);
  charts = Array.from(new Set(charts));
  console.log(charts);
  
  return data;
};

// Render the graphic(s). Called by pym with the container width.
  var render = function(data) {
    // Render the chart!
    var container = "#stacked-bar-chart";
    var element = document.querySelector(container);
    var width = element.offsetWidth;
    var containerElement = d3.select(container);
    containerElement.html("");

    charts.forEach(function(d,i) {
      var chartData = data.filter(function(v) {
        return v.chart == d;
      });
    
      containerElement.append('div')
        .attr('class', 'chart ' + classify(d));
      var showTitle =  true;
      
      renderStackedBarChart({
        container: container + ' .chart.' + classify(d),
        width,
        data: chartData,
        labelColumn: "label",
        title: d,
        showTitle
        //nameColumn: "name"
      });
    })

    // Update iframe
    if (pymChild) {
      pymChild.sendHeight();
    }
  };

/*
 * Initially load the graphic
 * (NB: Use window.load to ensure all images have loaded)
 */
window.onload = onWindowLoaded;
